
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import SettingsGroup from '../../../views/Settings/Group/index.vue'
import SettingsItem from '../../../views/Settings/Item/index.vue'
import SettingsSwitch from '../../../views/Settings/Switch/index.vue'
import { Observer } from 'mobx-vue'
import { Bind, Debounce } from 'lodash-decorators'
import type { PrivacyConfig } from '@xt/client/entities/my-v2/settings-privacy'

@Observer
@Component({
  components: {
    SettingsGroup,
    SettingsItem,
    SettingsSwitch
  }
})
export default class MySettingsPrivacy extends Vue {
  get UserStore() {
    return this.$store.$storeUser
  }

  get PageStore() {
    return this.$store.$myV2.Settings.Priavcy
  }

  @Debounce(500, { leading: true, trailing: false })
  @Bind()
  async handleClickItem(item: PrivacyConfig) {
    const isSuccess = await this.PageStore.onChangePrivacySettings(item)

    if (isSuccess) {
      this.$message.success('设置成功')
    }
  }

  created(): void {
    this.PageStore.loadPrivacySettings(this.UserStore.UserInfo.id)
  }

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
